import OrderItem from './OrderItem';
import Model from './Model';
import _ from 'lodash';

export default class Order implements Model {

    private orderItems:Array<OrderItem> = [];
    private starOrders:Array<Array<OrderItem>> = [];
    private starOrderCandidates:Array<OrderItem> = [];
    private day:Date;

    /**
     * Getter $day
     * @return {Date}
     */
	public get $day(): Date {
		return this.day;
	}

    /**
     * Getter $orderConfirmed
     * @return {boolean}
     */
	public get $orderConfirmed(): boolean {
		return this.orderConfirmed;
	}

    /**
     * Setter $day
     * @param {Date} value
     */
	public set $day(value: Date) {
		this.day = value;
	}

    /**
     * Setter $orderConfirmed
     * @param {boolean} value
     */
	public set $orderConfirmed(value: boolean) {
		this.orderConfirmed = value;
	}
    private orderConfirmed:boolean;


	constructor($day: Date, $orderConfirmed: boolean,$orderItems:OrderItem[] = []) {
		this.day = $day;
        this.orderConfirmed = $orderConfirmed;
        $orderItems.forEach(orderItem => {
            this.addOrderItem(orderItem)
        });

	}
    
    

    /**
     * Getter $orderItems
     * @return {Array<OrderItem>}
     */
	public get $orderItems(): Array<OrderItem> {

		return this.orderItems;
	}

    /**
     * Setter $orderItems
     * @param {Array<OrderItem>} value
     */
	public set $orderItems(value: Array<OrderItem>) {
		this.orderItems = value;
    }
    
    public addOrderItem(orderItem: OrderItem) {
       
        this.$orderItems.push(orderItem)

        if (orderItem.isStarorder()) {
            this.starOrderCandidates.push(orderItem)
        }

        if (this.starOrderCandidates.length >= 7) {
            this.starOrders.push([
                ...this.starOrderCandidates
            ]);
            this.starOrderCandidates = []
        }

    }



    public removeItem(orderItem:OrderItem) {

         _.remove(this.$orderItems,(item:OrderItem) => {
	        return orderItem.$id === item.$id
        });
         this.orderItems = [
             ...this.orderItems
         ]

    }

    updateItem(orderItem:OrderItem) {
	    this.removeItem(orderItem);
        this.addOrderItem(orderItem);

    }

    public get length() {
        return this.$orderItems.length
    }

    public getPrice() {
        let price = 0;
        this.$orderItems.forEach(orderItem => {
            price += this.calcOrderItemPrice(orderItem);
        })
        return price
    }

    private isInStarorder(orderItem: OrderItem) {
        let result = false;
        this.getStarorders().forEach(starorder => {
            if (starorder.includes(orderItem)) {
                result = true;
                return
            }
        });
        return result;
    }

    public getStarorders() {
        let starorders = _.chunk(this.starordersByPrice,7);
        return starorders.filter(starorder => starorder.length === 7)
    }

    public getRegularOrders() {

	   return _.difference(this.$orderItems,_.flatten(this.getStarorders()));
    }

    public calcOrderItemPrice(orderItem: OrderItem) {

        if (orderItem.isStarorder()) {
            let maxIndex = this.getStarorders().length * 7;
            let actualTimeIndex = this.starOrdersByTime.indexOf(orderItem);
            if (actualTimeIndex < maxIndex) {
                return 6
            }
                let timeIndex = this.starOrdersByTime.indexOf(orderItem)
                return this.starordersByPrice[timeIndex].getPrice()

        }


        return orderItem.getPrice()
    }

    public get starordersByPrice() {
        return _.orderBy(this.orderItems.filter(orderItem => (orderItem.isStarorder()))
            ,(item) => (item.getPrice())
            ,['desc']);
    }

    public get starOrdersByTime() {

        return _.orderBy(this.orderItems.filter(orderItem => (orderItem.isStarorder()))
            ,['$createdAt']
            ,['asc']);

    }


}